// extracted by mini-css-extract-plugin
export default {"pageWrap":"Pd-z","fullWidth":"Qd-z","heading":"Rd-z","fullBleed":"Sd-z","hidden":"Td-z"};